"use strict";
exports.__esModule = true;
exports.BALANCE_OUT_OF_RANGE = void 0;
exports.BALANCE_OUT_OF_RANGE = {
    RENT_TRACKER_MAIN_TEXT: 'Your rent balance is different than estimated',
    RENT_TRACKER_SUBTEXT: 'Confirm how much you’d like Flex to pay your property this month.',
    CTA: 'Confirm rent amount',
    BALANCE_TOO_HIGH: {
        HEADER: 'Your rent balance is higher than estimated',
        CAN_OVERWRITE_SUBTEXT: 'Please enter the exact amount you’d like Flex to pay your property this month.',
        CANNOT_OVERWRITE_SUBTEXT: 'Please confirm you’d like Flex to pay your property {{rentAmount}} this month.',
        SURVEY_HEADER: 'Why is your rent bill higher than your estimate?',
        PAYMENT_SCHEDULE: {
            HEADER: 'Review payment schedule',
            SUBTEXT: 'Flex will submit your full rent of {{amount}} directly to your property after your 1st payment is completed. ',
            CTA: 'Confirm payment schedule',
            SUCCESS_MODAL: {
                HEADER: 'All set!',
                SUBTEXT: 'We’ve successfully updated your rent amount to {{amount}}. It may take up to an hour for the service issue status to be resolved.',
                CTA: 'Close'
            },
            IN_PROGRESS_MODAL: {
                HEADER: 'Rent amount update already in progress',
                SUBTEXT: 'You’ve already made a request to update your bill amount. Please be patient while we process the request.',
                CTA: 'Close'
            }
        }
    },
    BALANCE_TOO_LOW: {
        HEADER: 'Your rent balance is lower than estimated',
        CAN_OVERWRITE_SUBTEXT: 'Please enter the exact amount you’d like Flex to pay your property this month.',
        CANNOT_OVERWRITE_SUBTEXT: 'Please confirm you’d like Flex to pay your property {{rentAmount}} this month.'
    },
    DONT_USE_FLEX_LINK_TEXT: 'Don’t use Flex this month',
    SERVICE_ISSUE_SCREEN_CTA: 'Confirm rent amount',
    CO_CANNOT_EXCEED_RENT_ERROR_TEXT: 'Cannot exceed {{bpMonth}} rent bill',
    CO_CANNOT_BE_LOWER_ERROR_TEXT: 'Cannot be less than {{bpMonth}} rent bill',
    CANNOT_EXCEED_RENT_ERROR_TEXT: 'Cannot exceed actual rent balance',
    CANNOT_BE_LOWER_ERROR_TEXT: 'Cannot be less than actual rent balance',
    ENTER_AN_AMOUNT_ERROR_TEXT: 'Please enter an amount',
    MONTH_RENT_LABEL: '{{currentMonth}} rent',
    ORIGINAL_ESTIMATE_LABEL: 'Original estimate',
    CO_ACTUAL_RENT_BALANCE_LABEL: '{{currentMonth}} rent bill',
    ACTUAL_RENT_BALANCE_LABEL: 'Actual rent balance',
    RENT_PAYMENT_AMOUNT_LABEL: 'Rent payment amount',
    CO_RENT_PAYMENT_AMOUNT_LABEL: 'Updated rent amount',
    ZERO_BALANCE: {
        RENT_TRACKER_MAIN_TEXT: 'We detected your rent bill is $0',
        RENT_TRACKER_SUBTEXT: 'Confirm your rent amount Flex should pay your property this month.',
        RENT_TRACKER_CTA: 'Confirm rent bill',
        HEADER: 'Your property has not posted your rent bill yet',
        BOLD_MAIN_TEXT: "To resolve this issue now, enter the amount you'd like Flex to pay your property this month.",
        SECONDARY_TEXT: 'If you prefer to wait for your property to post your rent bill, we will continue to check until the 5th.',
        SERVICE_ISSUE_SCREEN_CTA: 'Confirm rent amount',
        INPUT_LABEL: 'Revised rent amount',
        ACTUAL_LABEL: '{{month}} rent bill',
        MAIN_TEXT_1: 'We need to know how much you’d like Flex to pay to continue your service.'
    },
    YARDI_ZERO_BALANCE: {
        RENT_TRACKER_MAIN_TEXT: 'We detected your rent bill is $0',
        RENT_TRACKER_SUBTEXT: 'Confirm your rent amount Flex should pay your property this month.',
        RENT_TRACKER_CTA: 'Confirm rent bill',
        HEADER: 'Your property has not posted your rent bill yet',
        MAIN_TEXT_1: 'We’ll continue to check for your rent bill until the 5th. Your property will not allow us to pay rent without a posted balance.',
        MAIN_TEXT_2: 'Contact your property manager to make sure they post your rent balance by {{bpMonth}} 5th. If your rent bill is not provided by then, you will not be able to use Flex this month and will be responsible for paying your full directly to your property.',
        CTA: 'Done'
    },
    DONT_USE_FLEX_MODAL: {
        HEADER: 'Are you sure you don’t want Flex to pay your rent?',
        MAIN_TEXT_1: 'If you continue, Flex will not pay your rent bill this month. ',
        MAIN_BOLD_TEXT_1: 'You will be responsible for paying your full rent directly to your property.',
        MAIN_TEXT_2: 'Your Flex plan will otherwise remain unchanged.',
        MAIN_TEXT_3: 'By proceeding, you have read and understand the above. ',
        MAIN_BOLD_TEXT_3: 'This cannot be reversed.',
        BACK_BUTTON: 'Back',
        CTA: 'Confirm'
    },
    RENT_TRACKER: {
        MAIN_TEXT: 'Your rent bill is different than estimated',
        SUB_TEXT: 'Confirm how much we should pay your property by {{bpEndDate}} in order to use Flex this month.',
        CTA: 'Confirm rent amount'
    },
    SERVICE_ISSUE_SCREEN: {
        BALANCE_TOO_HIGH_HEADER: 'Your rent bill is higher than estimated',
        BALANCE_TOO_LOW_HEADER: 'Your rent bill is lower than estimated',
        NO_OVERRIDE_SUBTEXT: 'Confirm that Flex should pay your property {{rentAmount}} this month. Resolve this issue by {{bpEndDate}}.',
        OVERRIDE_SUBTEXT: 'Enter the exact amount you’d like Flex to pay your property. Resolve this issue by {{bpEndDate}}.'
    }
};
